import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import classnames from 'classnames';
import { observer } from 'mobx-react';
// import logo from '../../../../images/20070-2-small.png';
import logo_compact from '../../../../images/logo/compact-logo.png';
import UserPanel from './userPanel';
import { MENUITEMS } from './menu';
import configDB from '../../../data/customizer/config';
import MenuItemSub from './MenuItemSub';
import MenuItemSidebarLink from './MenuItemSidebarLink';
import MenuItem from './MenuItem';
import appState from '../../../storages/mobx/appState';
import authStorage from '../../../storages/mobx/authStorage';

const Sidebar = (props) => {
  const [margin, setMargin] = useState(0);
  const [width, setWidth] = useState(0);
  const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(true);
  const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
  const [hideRightArrow, setHideRightArrow] = useState(true);
  const [hideLeftArrow, setHideLeftArrow] = useState(true);
  const [mainmenu, setMainMenu] = useState(MENUITEMS);
  const { wrapper } = configDB.data.settings.sidebar;
  const layout = 'ltr'; // useSelector((content) => content.Customizer.layout);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    const currentUrl = window.location.pathname;

    // eslint-disable-next-line
        mainmenu.filter(items => {
      if (items.path === currentUrl) setNavActive(items);
      if (!items.children) return false;
      // eslint-disable-next-line
            items.children.filter(subItems => {
        if (subItems.path === currentUrl) setNavActive(subItems);
        if (!subItems.children) return false;
        // eslint-disable-next-line
                subItems.children.filter(subSubItems => {
          if (subSubItems.path === currentUrl) {
            setNavActive(subSubItems);
            return true;
          }

          return false;
        });
        return subItems;
      });
      return items;
    });

    const timeout = setTimeout(() => {
      const elmnt = document.getElementById('myDIV');
      const menuWidth = elmnt.offsetWidth;
      if (menuWidth > window.innerWidth) {
        setHideRightArrow(false);
        setHideLeftArrowRTL(false);
      } else {
        setHideRightArrow(true);
        setHideLeftArrowRTL(true);
      }
    }, 500);

    return () => {
      // eslint-disable-next-line
            window.removeEventListener('resize', handleResize)
      clearTimeout(timeout);
    };
    // eslint-disable-next-line
    }, []);

  const handleResize = () => {
    setWidth(window.innerWidth - 310);
  };

  const setNavActive = (item) => {
    // eslint-disable-next-line
        MENUITEMS.filter(menuItem => {
      // eslint-disable-next-line
            if (menuItem != item) menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item)) menuItem.active = true;
      if (menuItem.children) {
        // eslint-disable-next-line
                menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
            return true;
          }
          return false;
        });
      }
      return menuItem;
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  // Click Toggle menu
  const toggletNavActive = (item) => {
    if (!item.active) {
      MENUITEMS.forEach((a) => {
        if (MENUITEMS.includes(item)) a.active = false;
        if (!a.children) return false;
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) return false;
          b.children.forEach((c) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
          });
        });
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const scrollToRight = () => {
    const elmnt = document.getElementById('myDIV');
    const menuWidth = elmnt.offsetWidth;
    const temp = menuWidth + margin;
    if (temp < menuWidth) {
      setMargin(-temp);
      setHideRightArrow(true);
    } else {
      setMargin((margin) => margin += (-width));
      setHideLeftArrow(false);
    }
  };

  const scrollToLeft = () => {
    // If Margin is reach between screen resolution
    if (margin >= -width) {
      setMargin(0);
      setHideLeftArrow(true);
    } else {
      setMargin((margin) => margin += width);
      setHideRightArrow(false);
    }
  };

  const scrollToLeftRTL = () => {
    if (margin <= -width) {
      setMargin((margin) => margin += -width);
      setHideLeftArrowRTL(true);
    } else {
      setMargin((margin) => margin += -width);
      setHideRightArrowRTL(false);
    }
  };

  const scrollToRightRTL = () => {
    const temp = width + margin;
    // Checking condition for remaing margin
    if (temp === 0) {
      setMargin(temp);
      setHideRightArrowRTL(true);
    } else {
      setMargin((margin) => margin += width);
      setHideRightArrowRTL(false);
      setHideLeftArrowRTL(false);
    }
  };

  const containerClass = classnames({
    'page-sidebar': true,
    open: !appState.isSidebarOpened,
  });

  return (
    <>
      <div className={containerClass}>
        <div className="main-header-left d-none d-lg-block">
          <div className="logo-wrapper compactLogo">
            <Link to="/">
              <img className="blur-up lazyloaded logo" src="../../../../images/logoglobenew.png" alt="" />
              <img className="blur-up lazyloaded logo" src="../../../../images/logoglobenew.png" alt="" />
              {/* <img className="blur-up lazyloaded logo" src="../../../../images/20070-2-small.png" alt="" /> */}
              {/* <img className="blur-up lazyloaded logo" src="../../../../images/20070-2-small.png" alt="" /> */}
              {/* <div> */}
              {/*  <div className="logo_title">Omni Channel</div> */}
              {/*  <div className="logo_subtitle">Все клиенты в одном месте</div> */}
              {/* </div> */}
            </Link>
          </div>
          <div className="appVersion">
            Version: &nbsp;
            {process.env.PACKAGE_VERSION}
          </div>
        </div>
        <div className="sidebar custom-scrollbar">
          <UserPanel />
          <ul
            className="sidebar-menu"
            id="myDIV"
            style={wrapper === 'horizontal_sidebar' ? layout === 'rtl'
              ? { marginRight: `${margin}px` } : { marginLeft: `${margin}px` } : { margin: '0px' }}
          >
            <li
              className={`left-arrow ${layout === 'rtl' ? hideLeftArrowRTL ? 'd-none' : '' : hideLeftArrow ? 'd-none' : ''}`}
              onClick={(wrapper === 'horizontal_sidebar' && layout === 'rtl') ? scrollToLeftRTL : scrollToLeft}
            >
              <i className="fa fa-angle-left" />
            </li>
            {
                            MENUITEMS
                              .filter((item) => authStorage.itemHasRole(item.roles))
                              .filter((item) => true)
                              .map((menuItem, i) => (
                                <li className={`${menuItem.active ? 'active' : ''}`} key={i}>
                                  {/* <MenuItemSidebarTitle title={menuItem.sidebartitle} /> */}
                                  {menuItem.type === 'sub' && (
                                  <MenuItemSub
                                    onClick={() => toggletNavActive(menuItem)}
                                    icon={<menuItem.icon className="pull-left" />}
                                    title={props.t(menuItem.title)}
                                  />
                                  )}
                                  {menuItem.type === 'link'
                                  && (
                                    <MenuItemSidebarLink
                                      path={menuItem.path}
                                      active={menuItem.active}
                                      onClick={() => toggletNavActive(menuItem)}
                                      icon={<menuItem.icon />}
                                      title={props.t(menuItem.title)}
                                      haveChildren={!!menuItem.children}
                                    />
                                  )}
                                  {menuItem.children
                                    ? (
                                      <ul
                                        className={`sidebar-submenu ${menuItem.active ? 'menu-open' : ''}`}
                                        style={menuItem.active ? { opacity: 1, transition: 'opacity 500ms ease-in' } : {}}
                                      >
                                        {menuItem.children.map((childrenItem, index) => (
                                          <li key={index} className={childrenItem.children ? childrenItem.active ? 'active' : '' : ''}>
                                            {/* <MenuItem */}
                                            {/*  item={childrenItem} */}
                                            {/*  onClick={() => toggletNavActive(childrenItem)} */}
                                            {/*  haveChildren={!!childrenItem.children} */}
                                            {/*  key={key} */}
                                            {/* /> */}
                                            {(childrenItem.type === 'sub')
                                              ? (
                                                <MenuItemSub
                                                  onClick={() => toggletNavActive(childrenItem)}
                                                  title={props.t(childrenItem.title)}
                                                  icon={<i className="fa fa-circle" />}
                                                />
                                              )
                                              : ''}

                                            {(childrenItem.type === 'link')
                                              ? (
                                                <MenuItemSidebarLink
                                                  path={childrenItem.path}
                                                  active={childrenItem.active}
                                                  onClick={() => toggletNavActive(childrenItem)}
                                                  icon={<i className="fa fa-circle" />}
                                                  title={props.t(childrenItem.title)}
                                                  haveChildren={!!childrenItem.children}
                                                />
                                              )
                                              : ''}
                                            {childrenItem.children
                                              ? (
                                                <ul className={`sidebar-submenu ${childrenItem.active ? 'menu-open' : 'active'}`}>
                                                  {childrenItem.children.map((childrenSubItem, key) => (
                                                    <MenuItem
                                                      item={childrenSubItem}
                                                      onClick={() => toggletNavActive(childrenSubItem)}
                                                      haveChildren={!!childrenSubItem.children}
                                                      key={key}
                                                    />
                                                  ))}
                                                </ul>
                                              )
                                              : ''}
                                          </li>
                                        ))}
                                      </ul>
                                    )
                                    : ''}
                                </li>
                              ))
                        }
            <li
              className={`right-arrow ${layout === 'rtl' ? hideRightArrowRTL ? 'd-none' : '' : hideRightArrow ? 'd-none' : ''}`}
              onClick={(wrapper === 'horizontal_sidebar' && layout === 'rtl') ? scrollToRightRTL : scrollToRight}
            >
              <i className="fa fa-angle-right" />
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default translate(observer(Sidebar));
